import React, { createContext, useContext, useRef, useEffect, useState, useCallback } from 'react';
import { Pose } from '@mediapipe/pose';

const PoseContext = createContext(null);

export function PoseProvider({ children }) {
  const poseRef = useRef(null);
  const [ready, setReady] = useState(false);
  const [preloadProgress, setPreloadProgress] = useState(0);
  const initStarted = useRef(false);

  useEffect(() => {
    if (initStarted.current) return;
    initStarted.current = true;

    const pose = new Pose({
      locateFile: (file) => {
        if (file.endsWith('.tflite') || file.endsWith('.binarypb')) {
          setPreloadProgress(60);
        } else if (file.endsWith('.wasm')) {
          setPreloadProgress(30);
        }
        return `https://cdn.jsdelivr.net/npm/@mediapipe/pose/${file}`;
      }
    });

    pose.setOptions({
      modelComplexity: 1,
      smoothLandmarks: true,
      minDetectionConfidence: 0.5,
      minTrackingConfidence: 0.5
    });

    // Inicializar el modelo enviando un frame vacío (canvas 1x1)
    const dummyCanvas = document.createElement('canvas');
    dummyCanvas.width = 1;
    dummyCanvas.height = 1;

    pose.onResults(() => {
      // Primera vez que devuelve resultado = modelo cargado
      if (!poseRef.current) {
        poseRef.current = pose;
        setPreloadProgress(100);
        setReady(true);
        console.log('[PoseContext] Modelo pre-cargado exitosamente');
      }
    });

    pose.send({ image: dummyCanvas }).catch(() => {
      // Si falla el dummy frame, igual marcamos como disponible
      // Los componentes harán fallback a crear su propia instancia
      console.warn('[PoseContext] No se pudo pre-cargar con dummy frame, se usará lazy init');
      poseRef.current = pose;
      setPreloadProgress(100);
      setReady(true);
    });

    return () => {
      // No cerrar pose aquí - se reutiliza durante toda la sesión
    };
  }, []);

  const getPose = useCallback(() => poseRef.current, []);

  return (
    <PoseContext.Provider value={{ getPose, ready, preloadProgress }}>
      {children}
    </PoseContext.Provider>
  );
}

export function usePoseContext() {
  return useContext(PoseContext);
}
